import React from 'react'
import { Card } from 'antd'
import ImageBox from '@/components/ImageBox'
// 复用 ModelItem 的样式（全局样式类名 model-card）

/**
 * 模型广告卡片组件
 * 样式和效果与 ModelItem 完全一致
 */
const ModelAdCard = ({ adData }) => {
  if (!adData) return null

  return (
    <Card
      className="model-card"
      style={{ cursor: "pointer" }}
      cover={
        <ImageBox
          src={adData.image}
          loading={false}
        />
      }
      onClick={() => {
        if (adData.link && adData.link !== '#') {
          window.open(adData.link, '_blank')
        }
      }}
    >
      {/* 单行布局：广告标题 + 广告标识 */}
      <div className="model-info-row">
        {/* 左侧：广告标题 */}
        <div className="model-title-container">
          <div className="model-title-scroll" title={adData.title}>
            <span className="model-title-text">{adData.title}</span>
            {/* 如果名称过长，复制一份用于无缝滚动 */}
            {adData.title && adData.title.length > 12 && (
              <span className="model-title-text">{adData.title}</span>
            )}
          </div>
        </div>

        {/* 右侧：广告标识 */}
        <div className="model-actions-wrapper">
          <span style={{
            fontSize: '11px',
            color: '#ff4d4f',
            fontWeight: 600,
            padding: '2px 6px',
            background: 'rgba(255, 77, 79, 0.1)',
            borderRadius: '4px',
            whiteSpace: 'nowrap'
          }}>广告</span>
        </div>
      </div>
    </Card>
  )
}

export default React.memo(ModelAdCard)

